


















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
  }
})

export default class printErrorModal extends Vue {

    title = "印刷エラー";
    message = "時間をおいて、再度お試しください。";

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            background: this.userConfigColor
        };
        return style;
    }
}
